export default __webpack_public_path__ + "static/media/otherGold.82adbb52.webp";